import { BillingCycleInfo } from "./components/BillingCycleInfo";
import { BillingDetailsCard } from "./components/BillingDetailsCard";
import { BillingDetailsHeader } from "./components/BillingDetailsHeader";
import { BillingSectionDivider } from "./components/BillingSectionDivider";
import { CreditsUsageSection } from "./components/CreditsUsageSection";
import { useAiActionsBilling } from "./hooks/useAiActionsBilling";

export const AiActionsBillingDetails = () => {
  const { billingDetails } = useAiActionsBilling();

  if (!billingDetails || billingDetails.status === "canceled") {
    return null;
  }

  const {
    free_quantity,
    usage_count,
    overage: isOverage,
    final_overage_price,
    price_overage,
    cycle,
    currency_symbol,
    progress,
  } = billingDetails;

  return (
    <BillingDetailsCard>
      <BillingDetailsHeader
        isOverage={isOverage}
        finalOveragePrice={final_overage_price}
        priceOverage={price_overage}
        currencySymbol={currency_symbol}
      />
      <BillingCycleInfo startDate={cycle.start_date} />
      <BillingSectionDivider />
      <CreditsUsageSection
        usageCount={usage_count}
        freeQuantity={free_quantity}
        isOverage={isOverage}
        progress={progress}
      />
    </BillingDetailsCard>
  );
};
